import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'

// ---------------- lib -------------------
import ElementUI from 'element-ui'

// ---------------- define ----------------------
import Api from './api'
import BaseComponents from '@/base'
import Validator from '@/assets/js/validator'
import MainDirective from '@/directives'
import MainMixins from '@/mixins'
import * as filter from '@/assets/js/filter'
import * as Util from '@/assets/js/util'


// ---------------- css --------------------
import '@/assets/style/index.scss'

// 全局过滤器注册
Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key])
});

// 全局util方法注册
Vue.prototype.$util = Util;

// 全局组件注册

Vue.use(ElementUI, { zIndex: 3000 })
Vue.use(Api)
Vue.use(BaseComponents)
Vue.use(Validator)
Vue.use(MainDirective)
Vue.use(MainMixins)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')